<app-header></app-header>
<div class="content_wrapper">
    <div class="panel-set">
        <div class="panel-pharse">

            <!--head section-->

            <div class="reg-head">
                <div class="phrase_edit_heading text-capitalize">
                    {{project}}
                </div>
            </div>

            <!--panel tab sec--->

            <div class="panel_data_phrase">
                <div class="ui-tabs-report">
                    <div class="container p-4">
                        <ul class="nav nav-tabs" id="tab-next-prev" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false"><i class="fa fa-envelope"></i><span>Notifications</span></a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link active" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false"><i class="fa fa-file-text-o"></i><span>Reports</span></a>
                            </li>
                        </ul>

                        <div class="tab-content" id="tab-next-prev-content">
                            <!--Notifications tab-->

                            <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
                                <div class="not-sec">
                                    <div class="not-table">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Frequency</th>
                                                    <th>Filter</th>
                                                    <th>Options</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let notification of notifications; let i=index;">
                                                    <td>{{notification.email}}</td>
                                                    <td>{{get_frequency_name(notification.frequency)}}</td>
                                                    <td>{{get_tag_name(notification.filters)}}</td>
                                                    <td><a (click)="edit_notification_popup(notification, i)"><span><img src="assets/images/edit.png"></span>Edit</a>&nbsp;
                                                        <a (click)="delete_notification(i)"><span><img src="assets/images/delete.png"></span>Delete</a></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- Button to Open the Modal -->
                                    <a class="btn panel_remove_btn" (click)="add_more_notification()">
                                        Add more notifications
                                    </a>
								<div class="save-note"><p><span><i class="fa fa-info-circle" aria-hidden="true"></i></span>Note: To see the changes, please click save button.</p></div>
                                </div>
                                <div class="panel_phrase_form_info">
                                    <div class="float-right">
                                        <!--<a class="panel_remove_btn" href="">Remove project</a>-->
                                        <button (click)="notification_settings()" class="panel_save_btn" href="">Save</button>
                                    </div>
                                </div>
                            </div>


                            <!--Reports tab-->


                            <div class="tab-pane fade show active" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
                                <form [formGroup]="reports_form" (ngSubmit)="report_settings()">
                                    <div class="reports_search_form">
                                        <ul formArrayName="reports">
                                            <li class="single_report" *ngFor="let report of reports.controls; let reportIndex=index" [formGroupName]="reportIndex">
                                                <div class="row user-row">
                                                    <div class="col-md-12" style="min-height:40px;">
                                                        <div class="additional-reports-edit-checkbox reports-heading row">
                                                            <div class="pull-left col-md-2">
                                                                <h4 class="mt10 big-light"><i class="fa fa-user"></i> Select recipient:</h4>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <input type="hidden" name="" id="" value="">

                                                                <select (change)="add_new_recipient($event)" formControlName="recipient" class="users-list-select" style="height:40px;">
                                                                    <option value="">select</option>
                                                                    <option *ngFor="let recipient of recipients" value="{{recipient}}">{{recipient}}</option>
                                                                    <option value="new">Add new recipient</option>
                                                                </select>

                                                                <!--                                                                <div class="reports_user_add_div new_report_user user_add_div" id="" style="display: none;">
                                                                                                                                    <input type="text" name="reports_user_add" class="reports_user_add_input" id="" value="">
                                                                                                                                    <input type="button" name="reports_user_add_btn" class="reports_user_add_btn" id="" value="Add">
                                                                                                                                    <div id="" class="error_form_div"></div>
                                                                                                                                </div>-->
                                                            </div>
                                                            <div class="pull-right col-md-4">
                                                                <a role="button" (click)="deleteReport(reportIndex)" class="btn-outline del_report"><i class="fa fa-trash-o"></i> Delete</a>
                                                            </div>
                                                        </div>
                                                        <div class="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div class="row">

                                                    <div class="additional-reports-edit col-md-6">
                                                        <div class="additional-reports-edit-checkbox">
                                                            <h4><i class="fa fa-file-text-o"></i> Daily reports</h4>
                                                            <label class="switch">
                                                                <input formControlName="daily_report" type="checkbox" checked>
                                                                <span class="slider round"></span>
                                                            </label>												
                                                        </div>
                                                        <div class="report-description daily-report-description active-settings">
                                                            <p>Sent to your inbox every day.</p>
                                                            <div>
                                                                <div class="additional-reports-edit-checkbox">
                                                                    <p><strong>If there are no new mentions from the last 24 hours:</strong></p>
                                                                    <select formControlName="daily_send_empty" class="send-if-zero">
                                                                        <option value="0">Do not send me empty reports</option>
                                                                        <option value="1">Send me empty reports</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="additional-reports-edit col-md-6">
                                                        <div class="additional-reports-edit-checkbox">
                                                            <h4><i class="fa fa-file-text-o"></i> Weekly reports</h4>
                                                            <label class="switch">
                                                                <input formControlName="weekly_report" type="checkbox" checked>
                                                                <span class="slider round"></span>
                                                            </label>												
                                                        </div>
                                                        <div class="report-description daily-report-description active-settings">
                                                            <p>Sent to your inbox every Monday.</p>
                                                            <div>
                                                                <div class="additional-reports-edit-checkbox">
                                                                    <p><strong>If there are no new mentions from the last 7 days:</strong></p>
                                                                    <select formControlName="weekly_send_empty" class="send-if-zero">
                                                                        <option value="0">Do not send me empty reports</option>
                                                                        <option value="1">Send me empty reports</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>

                                            <div id="add_new_report_div" class="row" style="margin-top:10px;">
                                                <div class="col-sm-12">
                                                    <a role="button" (click)="addReport()" class="btn-outline pull-left add_report">+ Add new recipient</a>
                                                </div>
                                            </div>

                                            <div class="panel_phrase_form_info">
                                                <div class="float-right">
                                                    <!--<a class="panel_remove_btn" href="">Remove project</a>-->
                                                    <button class="panel_save_btn" href="">Save</button>
                                                </div>
                                            </div>

                                        </ul>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<!-- The Modal -->

<div id="notification_form_model" class="notification_form_model" *ngIf="show_notification_form">
    <form [formGroup]="notification_form" (ngSubmit)="save_notification_in_array(notification_form.value)" id="notification_form">
        <div class="modal-dialog modal-md add_new_form ">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Adding the new notification</h4>
                </div>
                <!-- Modal body -->
                <div class="modal-body">
                    <span class="error_message" *ngIf="err.common">{{err.common}}</span>
                    <div class="form-group">
                        <label for="projectname">Email Address</label>
                        <select formControlName="email" id="ns-email" class="form-control">
                            <option value="">Select Email</option>
                            <option *ngFor="let recipient of recipients" value="{{recipient}}">{{recipient}}</option>
                        </select>
                        <span class="error_message" *ngIf="err.email">{{err.email}}</span>
                    </div>
                    <div class="form-group">
                        <label for="projectname">Frequency</label>
                        <select formControlName="frequency" class="form-control" id="ns-frequency">
                            <option value="">Select Frequency</option>
                            <option value="60">every hour</option>
                            <option value="360">every 6 hours</option>
                            <option value="720">every 12 hours</option>
                            <option value="1440">once a day</option>
                            <option value="10080">every week</option>
                            <option value="43200">every month</option>
                        </select>
                        <span class="error_message" *ngIf="err.frequency">{{err.frequency}}</span>
                    </div>
                    <div class="form-group">
                        <a class="btn panel_remove_btn" (click)="tag_form()" style="cursor:pointer;">Add New Filter</a>
                    </div>
                    <div class="form-group">
                        <label for="projectname">Filters</label>
                        <select formControlName="filters" class="form-control" id="ns-filters">
                            <option value="">None</option>
                            <option *ngFor="let tag of tags" value="{{tag.id}}">{{tag.name}}</option>							
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button (click)="close_notification_form()" type="button" class="btn btn-danger">Close</button>
                    <button type="submit"  class="panel_save_btn">Save</button>
                </div>
            </div>
        </div>
    </form>
</div>



<!-- Modal -->

<div id="tag_form_model" class="tag_form_model" *ngIf="show_tag_form">
    <!--<form [formGroup]="tag_form" (ngSubmit)="save_tag(tag_form.value)" id="tag_form">-->
    <div class="modal-dialog modal-sm add_new_form ">
        <div class="modal-content">
		<div class="modal-header">
                <h4 class="modal-title">Add New Filter</h4>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <span class="error_message" *ngIf="tag_err.common">{{tag_err.common}}</span>
                <div class="form-group">
                    <label for="projectname">Filter Name</label>
                    <input class="form-control" id="tag-name">
                    <span class="error_message" *ngIf="tag_err.name">{{tag_err.name}}</span>
                </div>
                <div class="form-group">
                    <label for="projectname">Filter by text</label>
                    <input class="form-control" id="tag-text">
                </div>
                <div class="form-group">
                    <label for="projectname">Sentiment Filter</label>
                    <div class="panel_filter_options mention-fit">
                        <ngx-slider [(value)]="sentimant_filter_value" [options]="sentimant_filter_options" (valueChange)="senitment_filter_event($event)"></ngx-slider>
                    </div>
                </div>
                <div class="form-group">
                    <label for="projectname">Language</label>
                    <div class="panel_filter_options mention-fit">
                        <select (change)="language_filter()" id="language_filter" class="form-control">
                            <option [selected]="language == 'any'" value="any">Any Language</option>
                            <option [selected]="language == 'en'" value="en">English</option>
                            <option [selected]="language == 'ar'" value="ar">Arabic</option>
                            <option [selected]="language == 'hr'" value="hr">Croatian</option>
                            <option [selected]="language == 'cs'" value="cs">Czech</option>
                            <option [selected]="language == 'da'" value="da">Danish</option>
                            <option [selected]="language == 'nl'" value="nl">Dutch</option>
                            <option [selected]="language == 'fi'" value="fi">Finnish</option>
                            <option [selected]="language == 'fr'" value="fr">French</option>
                            <option [selected]="language == 'de'" value="de">German</option>
                            <option [selected]="language == 'hu'" value="hu">Hungarian</option>
                            <option [selected]="language == 'id'" value="id">Indonesian</option>
                            <option [selected]="language == 'it'" value="it">Italian</option>
                            <option [selected]="language == 'ko'" value="ko">Korean</option>
                            <option [selected]="language == 'no'" value="no">Norwegian</option>
                            <option [selected]="language == 'pl'" value="pl">Polish</option>
                            <option [selected]="language == 'pt'" value="pt">Portuguese</option>
                            <option [selected]="language == 'ro'" value="ro">Romanian</option>
                            <option [selected]="language == 'ru'" value="ru">Russian</option>
                            <option [selected]="language == 'sk'" value="sk">Slovak</option>
                            <option [selected]="language == 'es'" value="es">Spanish</option>
                            <option [selected]="language == 'sv'" value="sv">Swedish</option>
                            <option [selected]="language == 'th'" value="th">Thai</option>
                            <option [selected]="language == 'tr'" value="tr">Turkish</option>
                            <option [selected]="language == 'vi'" value="vi">Vietnamese</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label for="projectname">Country</label>
                    <div class="panel_filter_options mention-fit">
                        <select class="form-control" (change)="filter_by_country($event)" [(ngModel)]="country">
                            <option [selected]="country.cca2 == ''" class="opt_one" value="">All</option>
                            <option [selected]="country.cca2 == country" class="opt_one" *ngFor="let country of countries" value="{{country.cca2}}">{{country.name.common}}</option>
                        </select>
                    </div>
                </div>
                <div class="form-group">
                    <label for="projectname">Channels</label>
                    <div class="panel_filter_options mention-fit">
                        <div class="categories_switch">
                            <div class="modal-cat">
                                <a class="">
                                    <div class="results_type"><i class="fa fa-globe"></i><p>All</p>
                                        <input class="hidden" type="checkbox" value="all" [checked]="checked_sm.all" (click)="sm_checkbox_event($event)">
                                    </div>
                                </a>
                                <a *ngIf="user_data.channels[project_id].twitter" class="">
                                    <div class="results_type"><i class="fa fa-twitter"></i><p>Twitter</p><input type="checkbox" value="twitter" [checked]="checked_sm.twitter" (click)="sm_checkbox_event($event)"></div>
                                </a>
                                <a *ngIf="user_data.channels[project_id].instagram" class="">
                                    <div class="results_type"><i class="fa fa-instagram"></i><p>Instagram</p><input type="checkbox" value="instagram" [checked]="checked_sm.instagram" (click)="sm_checkbox_event($event)"></div>
                                </a>
                            </div>
                            <div class="modal-cat">
                                <a *ngIf="user_data.channels[project_id].facebook" class="">
                                    <div class="results_type"><i class="fa fa-facebook"></i><p>Facebook</p><input type="checkbox" value="facebook" [checked]="checked_sm.facebook" (click)="sm_checkbox_event($event)"></div>
                                </a>
                                <a *ngIf="user_data.channels[project_id].youtube" class="">
                                    <div class="results_type"><i class="fa fa-play"></i><p>YouTube</p><input type="checkbox" value="youtube" [checked]="checked_sm.youtube" (click)="sm_checkbox_event($event)"></div>
                                </a>
                                <a *ngIf="user_data.channels[project_id].reviews" class="">
                                    <div class="results_type"><i class="fa fa-comment"></i><p>Reviews</p><input type="checkbox" value="reviews" [checked]="checked_sm.reviews" (click)="sm_checkbox_event($event)"></div>
                                </a>
                            </div>
                            <div class="modal-cat">
                                <a *ngIf="user_data.channels[project_id].web" class="">
                                    <div class="results_type"><i class="fa fa-share-alt"></i><p>Web</p><input type="checkbox" value="web" [checked]="checked_sm.web" (click)="sm_checkbox_event($event)"></div>
                                </a>
                                <a *ngIf="user_data.channels[project_id].others" class="">
                                    <div class="results_type"><i class="fa fa-rss"></i><p>Others</p><input type="checkbox" value="others" [checked]="checked_sm.others" (click)="sm_checkbox_event($event)"></div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button (click)="close_tag_form()" type="button" class="btn btn-danger">Close</button>
                <button (click)="save_tag()" type="submit" class="btn btn-success">Save</button>
            </div>
        </div>
    </div>
    <!--</form>-->
</div>

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>
<app-footer></app-footer>